import { isLocalEnv } from '@tmap-web-lib/utils'
import {
  STORAGE_KEY_LIFE_DEV_TOOL_ACCESS_KEY,
  STORAGE_KEY_LIFE_STORE_ACCESS_KEY,
  STORAGE_KEY_LIFE_INSURANCE_TOOLTIP_SHOWN,
  STORAGE_KEY_LIFE_REWARD_SHOPPING_TOKEN,
} from './storage-keys'

export function pickAccessKey(defaultAccessKey?: string) {
  let accessKey = defaultAccessKey

  if (localStorage.getItem(STORAGE_KEY_LIFE_DEV_TOOL_ACCESS_KEY)) {
    accessKey = localStorage.getItem(STORAGE_KEY_LIFE_DEV_TOOL_ACCESS_KEY) || accessKey
  }

  if (isLocalEnv() && !accessKey) {
    accessKey = localStorage.getItem(STORAGE_KEY_LIFE_STORE_ACCESS_KEY) || accessKey
  }
  return accessKey || ''
}

const REWARD_SHOPPING_TOKEN_TTL = 12 * 60 * 60 * 1000 // 12시간

interface RewardShoppingTokenStorage {
  token: string;
  savedAt: number;
}

export function saveRewardShoppingToken(token: string) {
  const value: RewardShoppingTokenStorage = { token, savedAt: Date.now() }
  sessionStorage.setItem(STORAGE_KEY_LIFE_REWARD_SHOPPING_TOKEN, JSON.stringify(value))
}

export function getRewardShoppingToken(): string | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY_LIFE_REWARD_SHOPPING_TOKEN)
    if (!raw) return null
    const { token, savedAt } = JSON.parse(raw) as RewardShoppingTokenStorage
    if (Date.now() - savedAt > REWARD_SHOPPING_TOKEN_TTL) return null
    return token
  } catch {
    return null
  }
}

/** 보험 툴팁 노출 이력 조회 */
export function getInsuranceTooltipShownCodes(): string[] {
  try {
    const stored = localStorage.getItem(STORAGE_KEY_LIFE_INSURANCE_TOOLTIP_SHOWN)
    return stored ? JSON.parse(stored) : []
  } catch {
    return []
  }
}

/** 보험 툴팁 노출 이력 저장 */
export function setInsuranceTooltipShownCodes(codes: string[]): void {
  localStorage.setItem(STORAGE_KEY_LIFE_INSURANCE_TOOLTIP_SHOWN, JSON.stringify(codes))
}